import React, { useState, useEffect } from "react";
import { Form, Row } from "react-bootstrap";
import InputBox from "../common/InputBox";
import SearchSelect from "../common/SearchSelect";
import Switch from "../common/Switch";
import { getIsobMiscData } from "../../services/isob-service";

export default function IsobTab4({ formValues, handleInputChange, error, setError, mandatoryFields, setMandatoryFields, getDropDownOptions, readOnly }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const [openSections, setOpenSections] = useState({ supplyChain: false, logistics: false, installation: false });
    const [supplyRemarks, setSupplyRemarks] = useState(formValues.supplyRemarks || "");
    const [logisticsRemarks, setLogisticsRemarks] = useState(formValues.logisticsRemarks || "");
    const [miscInstallationRemarks, setMiscInstallationRemarks] = useState(formValues.miscInstallationRemarks || "");

    useEffect(() => {
        // if (!readOnly) return;
        setSupplyRemarks(formValues.supplyRemarks || "");
        setLogisticsRemarks(formValues.logisticsRemarks || "");
        setMiscInstallationRemarks(formValues.miscInstallationRemarks || "");
    }, [formValues.supplyRemarks, formValues.logisticsRemarks, formValues.miscInstallationRemarks, readOnly]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 767);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleSection = (key) => {
        setOpenSections(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const handleSupplyRemarks = (e) => {
        const val = e.target.value.slice(0, 500);
        setSupplyRemarks(val);
        handleInputChange({ target: { name: "supplyRemarks", value: val } });
    };

    const handleLogisticsRemarks = (e) => {
        const val = e.target.value.slice(0, 500);
        setLogisticsRemarks(val);
        handleInputChange({ target: { name: "logisticsRemarks", value: val } });
    };

    const handleInstallationRemarks = (e) => {
        const val = e.target.value.slice(0, 500);
        setMiscInstallationRemarks(val);
        handleInputChange({ target: { name: "miscInstallationRemarks", value: val } });
    };


    const renderSupplyChainContent = () => (
        <div className="isob-supply-chain-section order-info-section-colored-norightmar">
            <Row className="modal-row">
                <SearchSelect
                    name="inspectionReqd"
                    id="inspectionReqd"
                    label="Inspection Reqd *"
                    value={formValues.inspectionReqd || ""}
                    onChange={handleInputChange}
                    readOnly={readOnly}
                    required={!readOnly}
                    fieldName="Inspection Required"
                    setError={setError}
                    error={error?.inspectionReqd}
                    mandatoryFields={mandatoryFields}
                    className={formValues.inspectionReqd !== "Yes" ? "select-one-third-width" : ""}
                    setMandatoryFields={setMandatoryFields}
                    option={[
                        <option key="Yes" value="Yes">Yes</option>,
                        <option key="No" value="No">No</option>,
                    ]}
                />
                {formValues.inspectionReqd === "Yes" && (
                    <>
                        <InputBox
                            label="Inspection At"
                            name="inspectionAt"
                            id="inspectionAt"
                            type="text"
                            value={formValues.inspectionAt || ""}
                            onChange={handleInputChange}
                            readOnly={readOnly}
                            error={error?.inspectionAt}
                            setError={setError}
                            mandatoryFields={mandatoryFields}
                            setMandatoryFields={setMandatoryFields}
                            fieldName="Inspection At"
                            isAlphanumeric
                            maxLength={100}
                        />
                        <InputBox
                            label="Inspection Agency"
                            name="inspectionAgency"
                            id="inspectionAgency"
                            type="text"
                            value={formValues.inspectionAgency || ""}
                            onChange={handleInputChange}
                            readOnly={readOnly}
                            error={error?.inspectionAgency}
                            setError={setError}
                            mandatoryFields={mandatoryFields}
                            setMandatoryFields={setMandatoryFields}
                            fieldName="Inspection Agency"
                            isAlphanumeric
                            maxLength={100}
                        />
                    </>
                )}
            </Row>
            {formValues.inspectionReqd === "Yes" && (
                <>
                    <Row className="modal-row">
                        <InputBox
                            label="Contact Name"
                            name="inspContactName"
                            id="inspContactName"
                            type="text"
                            value={formValues.inspContactName || ""}
                            onChange={handleInputChange}
                            readOnly={readOnly}
                            error={error?.inspContactName}
                            setError={setError}
                            mandatoryFields={mandatoryFields}
                            setMandatoryFields={setMandatoryFields}
                            fieldName="Contact Name"
                            isAlphanumeric
                            maxLength={50}
                        />
                        <InputBox
                            label="Contact Mobile"
                            name="inspContactMobile"
                            id="inspContactMobile"
                            type="text"
                            value={formValues.inspContactMobile || ""}
                            onChange={handleInputChange}
                            readOnly={readOnly}
                            error={error?.inspContactMobile}
                            setError={setError}
                            mandatoryFields={mandatoryFields}
                            setMandatoryFields={setMandatoryFields}
                            fieldName="Contact Mobile"
                            isMobileNumber
                            maxLength={10}
                        />
                        <InputBox
                            label="Contact Address"
                            name="inspContactAddress"
                            id="inspContactAddress"
                            type="text"
                            value={formValues.inspContactAddress || ""}
                            onChange={handleInputChange}
                            readOnly={readOnly}
                            error={error?.inspContactAddress}
                            setError={setError}
                            mandatoryFields={mandatoryFields}
                            setMandatoryFields={setMandatoryFields}
                            fieldName="Contact Address"
                            isAlphaNumericSpaceAtDot
                            maxLength={50}
                        />
                    </Row>
                    <Form.Group className="scope-details mb-2 isob-textarea-group">
                        <Form.Label className="isob-textarea-label">Supply remarks</Form.Label>
                        <InputBox
                            type="text"
                            as="textarea"
                            style={{
                                "max-width": '98%',
                                "min-width": '50%',
                                "width": '-webkit-fill-available',
                                "min-height": "30px"                            }}
                            name="supplyRemarks"
                            id="supplyRemarks"
                            label="Write down remarks on supply chain"
                            value={supplyRemarks}
                            onChange={handleSupplyRemarks}
                            readOnly={readOnly}
                            fieldName="Supply chain remarks"
                            setError={setError}
                            error={error?.supplyRemarks}
                            // maxLength={500}
                            isAlphaNumericSpaceAtDot
                        />
                        <div className="isob-textarea-count">{(supplyRemarks).length} / 500 chars</div>
                    </Form.Group>
                </>
            )}
        </div>
    );

    const renderLogisticsContent = () => (
        <div className="isob-logistics-section order-info-section-colored-norightmar">
            <Row className="modal-row">
                <InputBox
                    label="Site Contact Person*"
                    name="siteContactPerson"
                    id="siteContactPerson"
                    type="text"
                    value={formValues.siteContactPerson || ""}
                    onChange={handleInputChange}
                    readOnly={readOnly}
                    error={error?.siteContactPerson}
                    setError={setError}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    fieldName="Site Contact Person*"
                    isAlphanumeric
                    maxLength={50}
                    required={!readOnly}
                    className={"input-one-third-width"}
                />
                <InputBox
                    label="Site Contact Mobile*"
                    name="siteContactMobile"
                    id="siteContactMobile"
                    type="text"
                    value={formValues.siteContactMobile || ""}
                    onChange={handleInputChange}
                    readOnly={readOnly}
                    error={error?.siteContactMobile}
                    setError={setError}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    fieldName="Site Contact Mobile*"
                    isMobileNumber
                    maxLength={10}
                    required={!readOnly}
                    className={"input-one-third-width"}
                />
            </Row>
            <Form.Group className="scope-details mb-2 isob-textarea-group">
                <Form.Label className="isob-textarea-label">Logistics Remarks</Form.Label>
                <InputBox
                    type="text"
                    as="textarea"
                    style={{
                        "max-width": '98%',
                        "min-width": '50%',
                        "width": '-webkit-fill-available',
                        "min-height": "30px"                    }}
                    name="logisticsRemarks"
                    id="logisticsRemarks"
                    label="Write down remarks on logistics remarks*"
                    value={logisticsRemarks}
                    onChange={handleLogisticsRemarks}
                    readOnly={readOnly}
                    required={!readOnly}
                    fieldName="Logistics remarks*"
                    error={error?.logisticsRemarks}
                    setError={setError}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    // maxLength={500}
                    isAlphaNumericSpaceAtDot
                />
                <div className="isob-textarea-count">{(logisticsRemarks).length} / 500 chars</div>
            </Form.Group>
        </div>
    );

    const renderInstallationContent = () => (
        <div className="isob-installation-section">
            <div className="order-info-section-colored-norightmar">
                <Row className="modal-row">
                    <SearchSelect
                        name="projectSiteRegulatoryAct"
                        id="projectSiteRegulatoryAct"
                        label="Project Site Regulatory Act*"
                        value={formValues.projectSiteRegulatoryAct || ""}
                        onChange={handleInputChange}
                        readOnly={readOnly}
                        required={!readOnly}
                        fieldName="Project Site Regulatory Act"
                        setError={setError}
                        error={error?.projectSiteRegulatoryAct}
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        option={getDropDownOptions ? getDropDownOptions("ProjectSiteAct") : []}
                        className={"select-one-third-width"}
                    />
                </Row>
            </div>
            <div className="order-info-section-colored-norightmar">
                <div className="installation-toggles-grid">
                    <div className="installation-toggle-item">
                        <Form.Label className="dealer-sac-toggle-label">QAP</Form.Label>
                        <Switch isOn={!!formValues.miscQap} handleToggle={(e) => handleInputChange({ target: { name: "miscQap", value: e.target.checked } })} index="miscQap" readOnly={readOnly} />
                    </div>
                    <div className="installation-toggle-item">
                        <Form.Label className="dealer-sac-toggle-label">Load test</Form.Label>
                        <Switch isOn={!!formValues.miscLoadTest} handleToggle={(e) => handleInputChange({ target: { name: "miscLoadTest", value: e.target.checked } })} index="miscLoadTest" readOnly={readOnly} />
                    </div>
                    <div className="installation-toggle-item">
                        <Form.Label className="dealer-sac-toggle-label">Site dimension reconfirmed</Form.Label>
                        <Switch isOn={!!formValues.miscSiteDimensionReconfirmed} handleToggle={(e) => handleInputChange({ target: { name: "miscSiteDimensionReconfirmed", value: e.target.checked } })} index="miscSiteDimensionReconfirmed" readOnly={readOnly} />
                    </div>
                </div>
            </div>
            <div className="order-info-section-colored-norightmar">
                <div className="installation-toggles-grid">
                    <div className="installation-toggle-item">
                        <Form.Label className="dealer-sac-toggle-label">Site readiness for installation</Form.Label>
                        <Switch isOn={!!formValues.miscSiteReadinessForInstallation} handleToggle={(e) => handleInputChange({ target: { name: "miscSiteReadinessForInstallation", value: e.target.checked } })} index="miscSiteReadinessForInstallation" readOnly={readOnly} />
                    </div>
                    <div className="installation-toggle-item">
                        <Form.Label className="dealer-sac-toggle-label">Visual inspection of floor</Form.Label>
                        <Switch isOn={!!formValues.miscVisualInspectionOfFloor} handleToggle={(e) => handleInputChange({ target: { name: "miscVisualInspectionOfFloor", value: e.target.checked } })} index="miscVisualInspectionOfFloor" readOnly={readOnly} />
                    </div>
                    <div className="installation-toggle-item">
                        <Form.Label className="dealer-sac-toggle-label">Existing racks to be removed</Form.Label>
                        <Switch isOn={!!formValues.miscExistingRacksToBeRemoved} handleToggle={(e) => handleInputChange({ target: { name: "miscExistingRacksToBeRemoved", value: e.target.checked } })} index="miscExistingRacksToBeRemoved" readOnly={readOnly} />
                    </div>
                </div>
            </div>
            <div className="order-info-section-colored-norightmar">
                <div className="installation-toggles-grid">
                    <div className="installation-toggle-item">
                        <Form.Label className="dealer-sac-toggle-label">Working warehouse</Form.Label>
                        <Switch isOn={!!formValues.miscWorkingWarehouse} handleToggle={(e) => handleInputChange({ target: { name: "miscWorkingWarehouse", value: e.target.checked } })} index="miscWorkingWarehouse" readOnly={readOnly} />
                    </div>
                    <div className="installation-toggle-item">
                        <Form.Label className="dealer-sac-toggle-label">Multiple floors</Form.Label>
                        <Switch isOn={!!formValues.miscMultipleFloors} handleToggle={(e) => handleInputChange({ target: { name: "miscMultipleFloors", value: e.target.checked } })} index="miscMultipleFloors" readOnly={readOnly} />
                    </div>
                    <div className="installation-toggle-item">
                        <Form.Label className="dealer-sac-toggle-label">Covered space available</Form.Label>
                        <Switch isOn={!!formValues.miscCoveredSpaceAvailable} handleToggle={(e) => handleInputChange({ target: { name: "miscCoveredSpaceAvailable", value: e.target.checked } })} index="miscCoveredSpaceAvailable" readOnly={readOnly} />
                    </div>
                </div>
            </div>
            <div className="order-info-section-colored-norightmar isob-installation">
                <Row className="modal-row">
                    <InputBox
                        label="Process checking & visit to factory"
                        name="processCheckingVisitToFactory"
                        id="processCheckingVisitToFactory"
                        type="text"
                        value={formValues.processCheckingVisitToFactory || ""}
                        onChange={handleInputChange}
                        readOnly={readOnly}
                        error={error?.processCheckingVisitToFactory}
                        setError={setError}
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        fieldName="Process checking & visit to factory"
                        isAlphaNumericSpaceAtDot
                        maxLength={200}
                    />
                    <SearchSelect
                        name="miscInstallationBy"
                        id="miscInstallationBy"
                        label="Installation by"
                        value={formValues.miscInstallationBy || ""}
                        onChange={handleInputChange}
                        readOnly={readOnly}
                        required={false}
                        fieldName="Installation by"
                        setError={setError}
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        option={getDropDownOptions ? getDropDownOptions("ScopeOfInstallation") : []}
                    />
                    <SearchSelect
                        name="scopeOfPowerSupply"
                        id="scopeOfPowerSupply"
                        label="Scope of power supply"
                        value={formValues.scopeOfPowerSupply || ""}
                        onChange={handleInputChange}
                        readOnly={readOnly}
                        required={false}
                        fieldName="Scope of power supply"
                        setError={setError}
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        option={getDropDownOptions ? getDropDownOptions("ScopeOfInstallation") : []}
                    />
                </Row>
                <Row className="modal-row">
                    <SearchSelect
                        name="scopeOfExistingRacksRemoval"
                        id="scopeOfExistingRacksRemoval"
                        label="Scope of existing racks removal"
                        value={formValues.scopeOfExistingRacksRemoval || ""}
                        onChange={handleInputChange}
                        readOnly={readOnly}
                        required={false}
                        fieldName="Scope of existing racks removal"
                        setError={setError}
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        option={getDropDownOptions ? getDropDownOptions("ScopeOfInstallation") : []}
                    />
                    <SearchSelect
                        name="scopeOfUnloading"
                        id="scopeOfUnloading"
                        label="Scope of unloading"
                        value={formValues.scopeOfUnloading || ""}
                        onChange={handleInputChange}
                        readOnly={readOnly}
                        required={false}
                        fieldName="Scope of unloading"
                        setError={setError}
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        option={getDropDownOptions ? getDropDownOptions("ScopeOfInstallation") : []}
                    />
                    <InputBox
                        label="Multiple floors details"
                        name="multipleFloorDetails"
                        id="multipleFloorDetails"
                        type="text"
                        value={formValues.multipleFloorDetails || ""}
                        onChange={handleInputChange}
                        readOnly={readOnly}
                        error={error?.multipleFloorDetails}
                        setError={setError}
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        fieldName="Multiple floors details"
                        isAlphaNumericSpaceAtDot
                        maxLength={200}
                    />
                </Row>
                <Form.Group className="scope-details mb-2 isob-textarea-group">
                    <Form.Label className="isob-textarea-label">Installation remarks</Form.Label>
                    <InputBox
                        type="text"
                        as="textarea"
                        style={{
                            "max-width": '98%',
                            "min-width": '50%',
                            "width": '-webkit-fill-available',
                            "min-height": "30px"
                        }}
                        name="miscInstallationRemarks"
                        id="miscInstallationRemarks"
                        label="Write down remarks on installation remarks"
                        value={miscInstallationRemarks}
                        onChange={handleInstallationRemarks}
                        readOnly={readOnly}
                        fieldName="Installation remarks"
                        setError={setError}
                        error={error?.miscInstallationRemarks}
                        // maxLength={500}
                        isAlphaNumericSpaceAtDot
                    />
                    <div className="isob-textarea-count">{(miscInstallationRemarks).length} / 500 chars</div>
                </Form.Group>
            </div>
        </div>
    );

    // Mobile View
    if (isMobile) {
        return (
            <div className="form-right-adjust isob-tab1-mobile">
                <div className="isob-tab1-accordion">
                    <div className="isob-tab1-accordion-header" onClick={() => toggleSection('supplyChain')}>
                        <span className="isob-tab1-accordion-title">Supply Chain</span>
                        <span className={`isob-tab1-accordion-arrow ${openSections.supplyChain ? 'open' : ''}`}>&#9662;</span>
                    </div>
                    {openSections.supplyChain && (
                        <div className="isob-tab1-accordion-body">
                            {renderSupplyChainContent()}
                        </div>
                    )}
                </div>

                <div className="isob-tab1-accordion">
                    <div className="isob-tab1-accordion-header" onClick={() => toggleSection('logistics')}>
                        <span className="isob-tab1-accordion-title">Logistics</span>
                        <span className={`isob-tab1-accordion-arrow ${openSections.logistics ? 'open' : ''}`}>&#9662;</span>
                    </div>
                    {openSections.logistics && (
                        <div className="isob-tab1-accordion-body">
                            {renderLogisticsContent()}
                        </div>
                    )}
                </div>

                <div className="isob-tab1-accordion">
                    <div className="isob-tab1-accordion-header" onClick={() => toggleSection('installation')}>
                        <span className="isob-tab1-accordion-title">Installation</span>
                        <span className={`isob-tab1-accordion-arrow ${openSections.installation ? 'open' : ''}`}>&#9662;</span>
                    </div>
                    {openSections.installation && (
                        <div className="isob-tab1-accordion-body">
                            {renderInstallationContent()}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    // Desktop View
    return (
        <div className="form-right-adjust">
            <div className="add-edit-form isob-project-details-section">
                <h6 className="section-subheading">Supply Chain</h6>
                {renderSupplyChainContent()}
                <h6 className="section-subheading">Logistics</h6>
                {renderLogisticsContent()}
                <h6 className="section-subheading">Installation</h6>
                {renderInstallationContent()}
            </div>
        </div>
    );
}
